export default __webpack_public_path__ + "static/media/order-snapshot.131aa47c.jpeg";